module.exports = __webpack_public_path__ + "img/1.632ef300.jpg";